import { Box, Paper, Typography } from "@mui/material";
import { PropsWithChildren } from "react";

export interface IPageHeaderProps {
    title: string;
}

function PageHeader({ children, title }: PropsWithChildren<IPageHeaderProps>) {
    return (
        <Paper sx={{ p: 2, display: 'flex', flexDirection: { xs: 'column', md: 'row' }, alignItems: 'center' }}>
            <Box sx={{ flexGrow: 1, mr: { xs: 0, md: (children ? 2 : 0) }, mb: { xs: (children ? 2 : 0), md: 0 } }}>
                <Typography variant="subtitle1" component="h2" sx={{ textTransform: 'uppercase' }}>
                    {title}
                </Typography>
            </Box>
            {children ? <Box sx={{ flexGrow: 0 }}>
                {children}
            </Box> : null}
        </Paper>
    );
}

export default PageHeader;